// Every button in a filter toolbar is medium (the fields' height) and carries the
// margin="dense" the mesf-core theme gives every TextField, so it sits on the fields'
// centre line.
export const TOOLBAR_BUTTON_SX = { mt: 1, mb: 0.5 } as const;
